"use client"
import { FC, useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { Heading, variables } from "politicamente-informados-ds";

interface AudioAttributes {
    id: number;
    src: string;
    autoplay: boolean;
    loop: boolean;
    preload: string;
}

interface AudioBlock {
    attrs: AudioAttributes;
}

const StyledAudio = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  width: auto;
  padding: 12px 0;
  cursor: pointer;
  color: ${variables.colors.secondary50};
  background-color: transparent;
  font-weight: normal;
  outline: none;
  transition: all 0.1s ease-in-out;

  & audio {
    display: none;
  }

  & svg {
    width: 32px;
    fill: ${variables.colors.secondary50};
    margin-right: 8px;
  }

  &:hover {
    opacity: 0.85;
  }
`;

const AudioPlayer: FC<AudioBlock> = ({ attrs }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioPlayer = useRef<HTMLAudioElement>(null);

    useEffect(() => {
        const player = audioPlayer.current;
        const handleAudioEnd = () => setIsPlaying(false);

        if (player) {
            player.addEventListener("ended", handleAudioEnd);
        }

        return () => {
            if (player) {
                player.removeEventListener("ended", handleAudioEnd);
            }
        };
    }, []);

    const onClickPlay = () => {
        const player = audioPlayer.current;
        if (!player) return;

        if (isPlaying) {
            player.pause();
            setIsPlaying(false);
        } else {
            player.play();
            setIsPlaying(true);
        }
    };

    return (
        <div onClick={onClickPlay}>
            <StyledAudio>
                <audio
                    ref={audioPlayer}
                    id={"player"}
                    controls
                    src={attrs.src}
                    autoPlay={attrs.autoplay}
                    loop={attrs.loop}
                    preload={attrs.preload}
                    controlsList="nodownload"
                />
                {isPlaying ? (
                    <svg
                        version="1.1"
                        id="Pause"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 60 60">
                        <g>
                            <path
                                d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
           S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
                            />
                            <path d="M33,46h8V14h-8V46z M35,16h4v28h-4V16z" />
                            <path d="M19,46h8V14h-8V46z M21,16h4v28h-4V16z" />
                        </g>
                    </svg>
                ) : (
                    <svg
                        version="1.1"
                        id="Play"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 60 60">
                        <g>
                            <path
                                d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30
		c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15
		C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"
                            />
                            <path
                                d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
		S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
                            />
                        </g>
                    </svg>
                )}
                <Heading>Ouvir Hino Nacional</Heading>
            </StyledAudio>
        </div>
    );
};

export default AudioPlayer;
